export default function CTASection() {
  return (
    <section className="relative bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row max-w-6xl mx-auto rounded-3xl overflow-hidden">
          {/* Left: Image collage */}
          <div className="lg:w-1/2 h-72 md:h-96 lg:h-auto relative bg-accent-50 overflow-hidden">
            {/* Polaroid-style product images */}
            <div className="absolute top-6 left-6 w-28 h-36 md:w-36 md:h-44 bg-background-50 rounded-lg shadow-sm rotate-[-4deg] p-2">
              <img
                src="https://readdy.ai/api/search-image?query=High-top%20canvas%20sneakers%20propped%20against%20red%20brick%20wall%20with%20green%20ivy%20vines%2C%20urban%20street%20aesthetic%2C%20warm%20golden%20side%20lighting%2C%20textured%20editorial%20product%20photography%2C%20rich%20earthy%20tones&width=320&height=400&seq=cta-shoe-v2-01&orientation=portrait"
                alt="Sneaker"
                className="w-full h-full object-cover rounded"
                loading="lazy"
              />
            </div>
            <div className="absolute top-12 right-8 w-24 h-32 md:w-32 md:h-40 bg-background-50 rounded-lg shadow-sm rotate-[3deg] p-2">
              <img
                src="https://readdy.ai/api/search-image?query=Woven%20straw%20beach%20bag%20sitting%20on%20wooden%20dock%20edge%20with%20calm%20lake%20water%20and%20forest%20reflection%20behind%2C%20peaceful%20summer%20afternoon%2C%20natural%20lifestyle%20photography%2C%20warm%20soft%20backlight%2C%20tranquil%20mood&width=300&height=380&seq=cta-bag-v2-02&orientation=portrait"
                alt="Bag"
                className="w-full h-full object-cover rounded"
                loading="lazy"
              />
            </div>
            <div className="absolute bottom-10 left-12 w-32 h-28 md:w-40 md:h-36 bg-background-50 rounded-lg shadow-sm rotate-[-2deg] p-2">
              <img
                src="https://readdy.ai/api/search-image?query=Classic%20vintage%20wristwatch%20lying%20beside%20steaming%20ceramic%20coffee%20cup%20on%20old%20wooden%20desk%20with%20open%20newspaper%2C%20cozy%20morning%20routine%20aesthetic%2C%20warm%20indoor%20lighting%2C%20nostalgic%20lifestyle%20photography%2C%20shallow%20depth%20of%20field&width=380&height=320&seq=cta-watch-v2-03&orientation=landscape"
                alt="Accessory"
                className="w-full h-full object-cover rounded"
                loading="lazy"
              />
            </div>
            <span className="absolute top-4 left-4 text-xs text-foreground-500 font-medium bg-background-50/80 px-2 py-1 rounded">
              Official Partner
            </span>
            <div className="absolute bottom-6 left-6">
              <p className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-950">Jump To</p>
              <p className="font-heading text-3xl md:text-5xl font-extrabold text-primary-500">Main Store</p>
              <p className="text-sm md:text-base text-foreground-600 font-light">kaspreadsheet.com</p>
            </div>
          </div>

          {/* Right: Content */}
          <div className="lg:w-1/2 bg-background-50 flex flex-col items-center justify-center px-6 md:px-12 py-12 md:py-16 text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
              Get Real Products
              <br />
              On Hipobuy Sheet
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-600 max-w-sm leading-relaxed">
              Ready to start shopping? Jump directly to the main store and explore thousands of products organized across 14 curated categories. Every category is updated regularly with the latest finds.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 mt-7 px-8 py-3.5 rounded-full bg-foreground-900 text-background-50 font-semibold text-sm hover:bg-foreground-800 transition-all cursor-pointer whitespace-nowrap"
            >
              Buy It Now
              <i className="ri-arrow-right-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}